module.exports = __webpack_public_path__ + "img/loading-quote-img-4.15cfff9f.png";